import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Survey from "@/pages/Survey";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Survey />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
